import Vue from 'vue'
import Router from 'vue-router'

/* layout*/
import Layout from 'views/layout/Layout';

//账号选择
import AccountSelect from 'views/account'

//工作台（经营数据）
import OperateData from 'views/operateData'

//子站管理
import SubStationManager from 'views/subStation/subManager'
import SubStationSet from 'views/subStation/subSet'
import SubStationData from 'views/subStation/subData'
import SubStationAlbum from 'views/subStation/subAlbum'

//分销商管理
import DistributorManager from 'views/distributorMana/distributorManager'
import DistributorData from 'views/distributorMana/distributorData'
import DistributorInfo from 'views/distributorMana/distributorInfo'


//待审核分销商
import PendCheck from 'views/pendCheck'

//订单管理
import OrderManager from 'views/orderManager'
import LockOrderManager from 'views/orderManager/lock'

// 数据中心
import incrementData from 'views/dataCenter/incrementData'
import lockUserDetail from 'views/dataCenter/lockUserDetail'
import authUserMobile from 'views/dataCenter/authUserMobile'
import albumsRank from 'views/dataCenter/albumsRank'

//预付货款管理
import advancePayment from 'views/advancePayment'
import Recharge from 'views/advancePayment/recharge'
import RechargeList from 'views/advancePayment/rechargeList'

//合伙人通知
import partnerNotice from 'views/partnerNotice'
//活动通知
import activityNotice from 'views/activityNotice'

/* error page*/
import Err404 from 'views/error/404';
import Err401 from 'views/error/401';


Vue.use(Router);
// console.log(this);
export const constantRouterMap = [
  {path: '/404', component: Err404, hidden: true},
  {path: '/401', component: Err401, hidden: true},
  {
    path: '/',
    component: Layout,
    redirect: '/account',
    hidden: true
  },
  {
    path: '/account',
    component: AccountSelect,
    hidden: true,
    name: 'Account'
  },
  {
    path: '/operate',
    component: Layout,
    redirect: '/operate/index',
    icon: 'icon-shop',
    text: '工作台',
    name: 'Operate',
    hidden: false,
    children: [
      {
        path: 'index',
        component: OperateData,
        text: '工作台',
        activeName: 'index'
      }
    ]
  },

]

export default new Router({
  mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  base: 'stage',
  routes: constantRouterMap
});

export const asyncRouterMap = [
  {
    path: '/substation',
    redirect: '/substation/manager',
    component: Layout,
    text: '子站管理',
    icon: 'icon-goods',
    permission: [11, 12, 13, 21, 22],
    hidden: false,
    children: [
      {
        path: 'manager',
        component: SubStationManager,
        name: 'SubManager',
        permission: [11, 12, 13, 21, 22],
        text: '子站管理',
        activeName: 'manager'
      },
      {path: 'set', component: SubStationSet, name: 'substationSet', permission: [11], text: '子站设置', activeName: 'set'},
      // {path: 'data', component: SubStationData, text: '子站数据', permission: [11, 12, 13, 21, 22], activeName: 'data'},
      {path: 'album', component: SubStationAlbum, text: '子站专辑', permission: [11, 12, 13, 21, 22], activeName: 'album'}]
  },
  {
    path: '/distributor',
    component: Layout,
    redirect: '/distributor/manager',
    icon: 'icon-distributor',
    text: '分销商管理',
    permission: [11, 12, 13],
    hidden: false,
    children: [{
      path: 'manager',
      component: DistributorManager,
      permission: [11, 12, 13],
      name: 'distributorManager',
      text: '分销商管理',
      activeName: 'manager'
    },
      // {path: 'data', component: DistributorData, permission: [11, 12, 13], text: '分销商数据', activeName: 'data'},
      {
        path: 'detail',
        component: DistributorInfo,
        permission: [11, 12, 13],
        name: 'distributorDetail',
        text: '分销商信息',
        hidden: true,
        activeName: 'manager'
      }]
  },
  /*{
    path: '/advancepayment',
    component: Layout,
    redirect: '/advancepayment/manager',
    icon: 'icon-distributor',
    text: '进货款管理',
    permission: [11, 12, 13],
    hidden: false,
    children: [{
      path: 'manager',
      component: advancePayment,
      permission: [11, 12, 13],
      name: 'advancePayment',
      text: '进货款管理',
      hidden: true,
      activeName: 'manager'
    },{
      path: 'recharge',
      component: Recharge,
      permission: [11, 12, 13],
      name: 'recharge',
      text: '充值',
      hidden: true,
      activeName: 'recharge'
    },{
      path: 'rechargelist',
      component: RechargeList,
      permission: [11, 12, 13],
      name: 'rechargelist',
      text: '充值申请',
      hidden: true,
      activeName: 'rechargelist'
    }]
  },*/
  /*{
    path: '/pendcheck',
    redirect: '/pendcheck/index',
    icon: 'icon-profile',
    component: Layout,
    text: '待审核分销商',
    hidden: false,
    children: [{ path: 'index', component: PendCheck, text:'待审核分销商', activeName:'index'}]
  },*/
  {
    path: '/ordermanager',
    redirect: '/ordermanager/index',
    icon: 'icon-order',
    component: Layout,
    text: '订单管理',
    hidden: false,
    children: [
      {
        path: 'index', 
        component: OrderManager, 
        text: '站外订单', 
        activeName: 'index'
      },
      {
        path: 'lock', 
        component: LockOrderManager, 
        text: 'APP内订单', 
        activeName: 'lock'
      }
    ]
  },
  {
    path: '/data/center',
    component: Layout,
    redirect: '/data/center/lock',
    icon: 'icon-rank',
    permission: [11, 12, 13, 21, 22],
    text: '数据中心',
    hidden: false,
    children: [
      {
        path: 'increment',
        component: incrementData,
        name: 'incrementData',
        // hidden: true,
        text: '用户增长',
        permission: [11, 12, 13],
        activeName: 'increment'
      },
      {
        path: 'rank',
        component: albumsRank,
        name: 'rankData',
        // hidden: true,
        text: '专辑排行',
        permission: [11, 12, 13],
        activeName: 'rank'
      },
      {
        path: 'lock',
        component: lockUserDetail,
        name: 'lockUserDetail',
        text: '锁定用户详情',
        permission: [11, 12, 13, 21, 22],
        activeName: 'lock'
      },
      {
        path: 'mobile',
        component: authUserMobile,
        name: 'authUserMobile',
        text: '授权手机号用户',
        permission: [11, 12, 13],
        activeName: 'mobile'
      }
    ]
  },
  {
    path: '/partnernotice',
    component: Layout,
    redirect: '/partnernotice/index',
    icon: 'icon-notice',
    text: '通知中心',
    permission: [11],
    children: [{
      path: 'index',
      component: partnerNotice,
      permission: [11],
      name: 'partnerNotice',
      text: '通知中心',
      activeName: 'index'
    }]
  },
  {
    path: '/partnernotice',
    component: Layout,
    redirect: '/partnernotice/index',
    icon: 'icon-notice',
    text: '通知中心',
    permission: [21],
    children: [{
      path: 'index',
      component: partnerNotice,
      permission: [21],
      name: 'partnerNotice',
      text: '通知中心',
      activeName: 'index'
    }]
  },
  {
    path: '/activityNotice',
    component: Layout,
    redirect: '/activityNotice/index',
    icon: 'icon-notice',
    text: '活动模板',
    permission: [11,21],
    children: [{
      path: 'index',
      component: activityNotice,
      permission: [11,21],
      name: 'activityNotice',
      text: '活动模板',
      activeName: 'index'
    }]
  },
]



// WEBPACK FOOTER //
// ./src/router/index.js